

export const esVacio = (v) => v === null || v === undefined || String(v).trim() === "";


export const ESTADOS_SOS = ["Pendiente", "Cerrado"];

export const normalizarEstado = (valor) => {
  const limpio = esVacio(valor) || valor === "N/A" || valor === "n/a" ? "" : valor;
  return ESTADOS_SOS.includes(limpio) ? limpio : "Pendiente";
};

export const esPendiente = (item) => normalizarEstado(item?.estado_final) !== "Cerrado";

export const escaparHTML = (valor) =>
  String(valor ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const RE_12H   = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})(?::(\d{2}))?\s*([AaPp])\.?[Mm]\.?$/;
const RE_24H   = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})(?::(\d{2}))?$/;
const RE_FECHA = /^(\d{4})-(\d{2})-(\d{2})$/;

export const parsearFecha = (valor) => {
  if (valor instanceof Date) return valor;
  if (typeof valor === "number") return new Date(valor);

  const texto = String(valor ?? "").trim();
  if (!texto) return new Date(NaN);

  const m12 = texto.match(RE_12H);
  if (m12) {
    const [, anio, mes, dia, hora, min, seg, meridiano] = m12;
    let h = Number(hora) % 12;
    if (meridiano.toLowerCase() === "p") h += 12;
    return new Date(Number(anio), Number(mes) - 1, Number(dia), h, Number(min), Number(seg || 0));
  }

  const m24 = texto.match(RE_24H);
  if (m24) {
    const [, anio, mes, dia, hora, min, seg] = m24;
    return new Date(Number(anio), Number(mes) - 1, Number(dia), Number(hora), Number(min), Number(seg || 0));
  }

  const mFecha = texto.match(RE_FECHA);
  if (mFecha) {
    const [, anio, mes, dia] = mFecha;
    return new Date(Number(anio), Number(mes) - 1, Number(dia));
  }

  return new Date(texto);
};

export const formatearFecha = (fecha) => {
  if (esVacio(fecha)) return "";
  const d = parsearFecha(fecha);
  if (isNaN(d)) return String(fecha);
  const pad = (n) => String(n).padStart(2, "0");
  const h = d.getHours();
  const ampm = h >= 12 ? "PM" : "AM";
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(h%12||12)}:${pad(d.getMinutes())} ${ampm}`;
};

export const enMilisegundos = (valor) => {
  const t = parsearFecha(valor).getTime();
  return isNaN(t) ? 0 : t;
};

export const fechaAhora = () => {
  const d = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const contarTiempoAtencion = (start, end) => {
  if (esVacio(start) || esVacio(end)) return "Sin información";
  const diff = parsearFecha(end) - parsearFecha(start);
  if (isNaN(diff) || diff < 0) return "Sin información";
  const mins  = Math.floor(diff / 60000) % 60;
  const horas = Math.floor(diff / 3600000) % 24;
  const dias  = Math.floor(diff / 86400000);
  const partes = [];
  if (dias)  partes.push(`${dias} días`);
  if (horas) partes.push(`${horas} horas`);
  if (mins)  partes.push(`${mins} minutos`);
  return partes.length ? partes.join(", ") : "Menos de 1 minuto";
};

export const fechaCreacionCruda = (item) =>
  !esVacio(item.fechayhoraCreacion)      ? item.fechayhoraCreacion
  : !esVacio(item.fecha_y_hora_creacion) ? item.fecha_y_hora_creacion
  : `${item.fecha || ""} ${item.hora || ""}`.trim();

export const construirObservacion = (item) => {
  const partes = [];

  if (!esVacio(item.observacion) && item.observacion !== "N/A") {
    const fecha = formatearFecha(item.fecha_y_hora_soporte) || "";
    const op    = item.operador || "Operador";
    partes.push(`[${fecha} — ${op}] ${item.observacion}`);
  }

  if (item.comentarios) {
    Object.values(item.comentarios).forEach(c => {
      partes.push(`[${c.fecha} — ${c.operador}] ${c.texto}`);
    });
  }

  return partes.join("\n") || "";
};

export const normalizarItem = (key, item, nitRuta) => {
  const creacionCruda = fechaCreacionCruda(item);

  return {
    ...item,
    key,
    id: key,
    fecha_creacion: formatearFecha(creacionCruda),
    fecha_y_hora_soporte: formatearFecha(item.fecha_y_hora_soporte),
    correo_final:   esVacio(item.correo)   ? (item.correoResidente   || "Sin información") : item.correo,
    telefono_final: esVacio(item.telefono) ? (item.telefonoResidente || "Sin información") : item.telefono,
    estado_final:   esVacio(item.estado)   ? "Pendiente" : item.estado,
    tiempo_atencion: !esVacio(item.fecha_y_hora_soporte)
      ? contarTiempoAtencion(creacionCruda, item.fecha_y_hora_soporte)
      : "Contando tiempo...",
    observacion: construirObservacion(item),
    nit: !esVacio(item.nit) ? String(item.nit) : String(nitRuta || ""),
    nombre_completo: item.nombreCompleto || item.nombre_completo || item.NombreCompleto || "",
    _creacion_ms: enMilisegundos(creacionCruda),
  };
};


const CAMPOS_DE_SOS = [
  "fechayhoraCreacion", "fecha_y_hora_creacion", "fecha", "hora",
  "estado", "tipo", "cliente", "nit",
  "nombreCompleto", "nombre_completo", "NombreCompleto",
  "latitud", "longitud", "telefono", "correo",
  "telefonoResidente", "correoResidente",
  "observacion", "comentarios", "operador", "fecha_y_hora_soporte",
];

export const esAlertaSOS = (item) => {
  if (!item || typeof item !== "object" || Array.isArray(item)) return false;
  return CAMPOS_DE_SOS.some((campo) => !esVacio(item[campo]));
};

export const esAlertaSonable = (fila) => !!fila && fila._creacion_ms > 0;

export const normalizarNodo = (valorNodo, nit) =>
  Object.entries(valorNodo || {})
    .filter(([, item]) => esAlertaSOS(item))
    .map(([key, item]) => normalizarItem(key, item, nit));

export const ordenarPorCreacion = (lista) =>
  [...lista].sort((a, b) => b._creacion_ms - a._creacion_ms);

export const idSOS = (alerta) => `${alerta?.nit}/${alerta?.key}`;
